<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    count: number
    /** Layout only, pill appearance is identical for every variant. */
    variant?: 'inline' | 'nav' | 'burger'
    ariaLabel?: string
  }>(),
  {
    variant: 'inline',
  }
)

const displayCount = computed(() => (props.count > 9 ? '9+' : String(props.count)))
</script>

<template>
  <span
    class="sa-notification-indicator"
    :class="`sa-notification-indicator--${variant}`"
    :aria-label="ariaLabel"
    :aria-hidden="ariaLabel ? undefined : true"
  >
    {{ displayCount }}
  </span>
</template>
